(function () {
	'use strict';
	$(document).ready(function () {
		function sendNewsletterForm(newsletterEmail) {
			const captcha_site_key = fhGetConfig('recaptcha_sitekey');

			grecaptcha.ready(function () {
				grecaptcha
					.execute(captcha_site_key)
					.then(function (token) {

						$.ajax({
							url: window.fh_config.ajax_url,
							method: 'post',
							timeout: 10000,
							data: {
								action: 'send_newsletter_form',
								newsletterEmail: newsletterEmail,
								token: token
							},
							success: function (data) {
								if (data) {
									const dataContent = JSON.parse(data);
									if (dataContent.status != 'error') {
										$('.ajax-success').slideDown();
										$('#newsletter-form').trigger('reset');
									} else {
										$('.ajax-error').slideDown();
										console.log(data);
									}
								} else {
									$('.ajax-error').slideDown();
									console.log('No data recived.');
								}
							},
							error: function (data) {
								$('.ajax-error').slideDown();
								console.log(data);
							},
							beforeSend: function () {
								$('.ajax-success').slideUp();
								$('.ajax-loading').slideDown();
								$('.ajax-error').slideUp();
							},
							complete: function () {
								$('.ajax-loading').slideUp();
							},
						});
					});
			});
		}

		$('#newsletter-submit').on('click', function (e) {
			e.preventDefault();
			const newsletterEmail = $('#newsletter-email').val();
			const newsletterConsent = $('#newsletter-consent:checked').length;

			$('.newsletter-error-email').slideUp();
			$('.newsletter-error-consent').slideUp();

			let isValid = true;

			if (!newsletterEmail) {
				$('.newsletter-error-email').slideDown();
				isValid = false;
			}

			if (newsletterConsent < 1) {
				$('.newsletter-error-consent').slideDown();
				isValid = false;
			}

			if (isValid) {
				sendNewsletterForm(newsletterEmail);
			}
		});

	});
}(jQuery));
